<template>
  <div class="root">
    <div class="bg">
      <picture>
        <source
          media="(min-width: 1024px)"
          srcset="@/assets/footer/desktop.png"
        />
        <img class="bgImg" src="@/assets/footer/mobile.png" alt="mobile" />
      </picture>
    </div>
    <div class="content">
      <div class="leftarea">
        <div class="tagline">
          {{
            `TRỞ THÀNH MỘT TRONG NHỮNG NGƯỜI ĐẦU TIÊN\n
          SỞ HỮU FLORENGE VỚI ƯU ĐÃI`
          }}
        </div>
        <div class="discount">OFF 350K</div>
        <button @click="redirectToCurnon" class="cta-btn">MUA NGAY</button>
      </div>
      <div class="rightarea">
        <div class="footnote">A Product By</div>
        <img src="@/assets/logo-curnon.svg" alt="logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerBlock",
  methods: {
    redirectToCurnon() {
      window.location.href =
        "https://curnonwatch.com/dong-ho/dong-ho-nu/dong-ho-nu-florenge";
    },
  },
};
</script>
<style lang="scss" scoped>
.root {
  position: relative;
  text-align: center;
  .bg {
    position: relative;
    z-index: 1;
    .bgImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .content {
    z-index: 2;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    .leftarea {
      flex: 1;
      padding: 16px 32px;
      .tagline {
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 26px;
        /* or 186% */

        text-align: center;

        color: rgba(0, 0, 0, 0.6);
        margin-bottom: 16px;
      }
      .discount {
        font-family: "Rollgates Fabulous", sans-serif;
        font-style: italic;
        font-weight: normal;
        font-size: 48px;
        line-height: 54px;
        /* identical to box height, or 112% */

        text-align: center;

        color: #d35c34;
        margin-bottom: 32px;
      }
      .cta-btn {
        cursor: pointer;
        border: none;
        padding: 24px 72px;
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        /* identical to box height, or 100% */

        text-align: center;

        color: #ffffff;
        background: #d35c34;
      }
    }
    .rightarea {
      margin: 10px;
      padding: 40px 0;
      background: black;

      .footnote {
        font-family: "SVN-Gotham", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 26px;
        color: #ffffff;
        padding-bottom: 24px;
      }
    }
  }
}

@media (min-width: 1024px) {
  .root {
    .bg {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
    .content {
      position: relative;
      flex-direction: row;
      white-space: nowrap;
      .leftarea {
        padding-left: 120px;
        flex: 1;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .tagline {
          text-align: left;
          white-space: pre-line;
        }
        .discount {
          text-align: left;
          font-size: 64px;
          line-height: 64px;
        }
      }
      .rightarea {
        flex: 0;

        padding-left: 120px;
        padding-right: 120px;
        padding-top: 144px;
        padding-bottom: 144px;
      }
    }
  }
}
</style>